export enum FilterFieldGuids {
	AnnotationStatus = 'e02ddcb8-2176-414b-9eae-36d1fea699bb',
	ArchiveJob = 'b737dc33-0c96-4eeb-a09c-ccbaecff06d5',
	AssistedReviewBatch = '2627fe9d-5cec-4894-9f1f-11915a5e2b04',
	AutoRedactionRuleId = 'bab6776a-d083-42a6-9089-ef276e59a0a0',
	BatesEnd = 'f4e88df9-4a7c-43ad-b140-21e4697efb0c',
	BriefcaseJobId = 'af9ea1a3-445e-48ff-b3ec-ad2922ca27fa',
	EmailThreadId = 'e203e2ab-1c64-488c-a452-088c15fff0c0',
	EmailTypeId = 'f43dc92e-7ad1-43a6-a924-573ea84813ad',
	ExcludeRedundantEmails = 'd126a195-ab8b-4b86-a78a-8775486ae3bb',
	Placeholder = 'd5a911ef-ae10-414f-817c-b5052311c6c5',
	ProductionJobId = 'd9ac63b3-6f1b-4aaa-8935-e28092ed4e0b',
	ProductionValidation = '3ee78d2e-aab6-4c0e-ba08-6e10141e9f97',
	RedactionStatus = '491c7487-742d-4b78-8c1a-3ebad4d2405a',
	ReviewSetId = '93812695-5eb4-4958-98be-d9007c75161b',
	ReviewedBy = 'de130785-80e4-4847-98d6-a0379fde7d19',
	ShowCurrentReviewBatch = '088cd979-c82f-4ea6-bd49-b677cb6c35b8',
	Translated = 'a33a1b5e-174b-4872-92a1-0d6ef565173f',
	DocsInFact = '7f4935bc-3fbe-4619-9dd2-7aae34685d7a'
}
